import { apiRequest } from "./http";

export interface SignupPayload {
    name: string;
    email: string;
    password: string;
}

export interface SignupResponse {
    message?: string;
    [key: string]: unknown;
}

export interface LoginPayload {
    email: string;
    password: string;
}

export interface LoginResponse {
    message?: string;
    [key: string]: unknown;
}

export function signup(payload: SignupPayload) {
    return apiRequest<SignupResponse>({
        endpoint: "/auth/signup",
        method: "POST",
        body: JSON.stringify(payload),
    });
}

export function login(payload: LoginPayload) {
    return apiRequest<LoginResponse>({
        endpoint: "/auth/login",
        method: "POST",
        body: JSON.stringify(payload),
    });
}
